// extracted by mini-css-extract-plugin
export default {"logo":"BullhornCard_logo__PYaPC"};